/* global jQuery */

import { Module } from 'wrapper6'

export default class ShippingDescription extends Module {
  ready (app) {
    this.handleShippingOptionsClick()
  }

  handleShippingOptionsClick () {
    jQuery('.col-2').on('click', '.woocommerce-shipping-method-div', (element) => {
      const jQueryElement = jQuery(element.target)
      const parentElement = jQuery(jQueryElement).closest('div.woocommerce-shipping-method-div')

      parentElement.find('input').prop('checked', 'checked')

      jQuery('.col-2 .shipping_options li.chosen-list').removeClass('chosen-list')
      parentElement.parent().addClass('chosen-list')

      jQuery(document.body).trigger('update_checkout')
    })
  }
}
